import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import React, { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { ImageInputField } from '..';

type ImageInputFieldProps = ComponentProps<typeof ImageInputField>;

type Props = {
  name: string;
  imageInput?: ImageInputFieldProps['imageInput'];
  fieldWrapperProps: Omit<ImageInputFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const ImageInputFieldController: React.FC<Props> = ({
  name,
  fieldWrapperProps,
  imageInput,
}) => {
  const { control } = useFormContext();

  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <ImageInputField
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
      imageInput={{ ...imageInput }}
      {...restField}
    />
  );
};
